import { axios, getConfigs, IRequestConfig, Report } from './api'

export interface FindReportsQuery {
  medicalOrderId: number | number[]
}

export class ReportService {
  private static readonly endpoint = 'reporting'

  static findMany(query: FindReportsQuery): Promise<Report[]> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        `${this.endpoint}/reports`,
        {},
      )
      configs.params = query
      axios(configs, resolve, reject)
    })
  }
}
